<agr-custom-dialog [data]="data" (confirm)="confirmImportVdm()" (cancel)="cancel()">
  @if (receivedTransportsTableConfig) {
    <div class="spacing--margin-top">
      <div class="text--bold">{{ 'sharedTransport.table.receivedTransports' | translate }}</div>
      @if (receivedTransportsTableConfig) {
        <agr-table [config]="receivedTransportsTableConfig"> </agr-table>
      }
    </div>
  }

  @if (dispatchedTransportsTableConfig) {
    <div class="spacing--margin-top">
      <div class="text--bold">
        {{ 'sharedTransport.table.dispatchedTransports' | translate }}
      </div>
      @if (dispatchedTransportsTableConfig) {
        <agr-table [config]="dispatchedTransportsTableConfig"> </agr-table>
      }
    </div>
  }
</agr-custom-dialog>

<ng-template #periodIdCell let-row="row">
  <div>{{ getPeriodName(row.periodId) }}</div>
</ng-template>

<ng-template #soilTypeIdCell let-row="row">
  <div>{{ getSoilTypeName(row.soilTypeId) }}</div>
</ng-template>

<ng-template #statusCell let-row="row">
  @if (isRowInvalid(row)) {
    <mat-icon class="text-color--warn">warning</mat-icon>
  }
</ng-template>
